import React, { useMemo } from 'react';
import { useFirestore } from 'reactfire';
import { nonUserFacingTags } from '@/config/templates';
import useSharedWidgets from '@/hooks/useSharedWidgets';
import TemplatesGalleryLoader from './Loading';
import TemplatesGroup from './Group';
import TemplatePopover, { useTemplatePopover } from './Popover';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TemplatesGallery = _ref => {
  let {
    templatesTag,
    selectedTemplateId,
    activeTemplateId,
    isPopoverVisible = true,
    onSelect
  } = _ref;
  const firestore = useFirestore();
  const {
    data: templates,
    status
  } = useSharedWidgets(firestore, {
    tags: ['array-contains', templatesTag]
  });
  const {
    anchorEl: focuseTemplateAnchorEl,
    focusTemplate,
    selectPopoverTemplate,
    closePopoverTemlpate
  } = useTemplatePopover(); // Group widget templates by tags

  const templateGroups = useMemo(() => {
    if (!templates.length) return {};
    return templates.reduce((acc, template) => {
      (template.tags || []).forEach(tag => {
        if (nonUserFacingTags.includes(tag)) return; // skip non-user-facing tags

        acc[tag] = acc[tag] || []; // empty array if not exists

        acc[tag].push(template);
      });
      return acc;
    }, {});
  }, [templates]);
  if (status === 'loading') return /*#__PURE__*/_jsx(TemplatesGalleryLoader, {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [Object.entries(templateGroups).map(_ref2 => {
      let [tag, templates] = _ref2;
      return /*#__PURE__*/_jsx(TemplatesGroup, {
        title: tag,
        activeTemplateId: selectedTemplateId || activeTemplateId,
        templates: templates,
        onSelect: onSelect,
        onFocus: selectPopoverTemplate,
        onFocusOut: closePopoverTemlpate
      }, tag);
    }), isPopoverVisible && /*#__PURE__*/_jsx(TemplatePopover, {
      anchorEl: focuseTemplateAnchorEl,
      template: focusTemplate,
      onClose: closePopoverTemlpate
    })]
  });
};

export default TemplatesGallery;